import { ApiException } from "./apiException";

export class ApiAuthorizationException extends ApiException {
    
}